<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.yjm">
      </p>
      <p>
        <b style="line-height:1.5;">
          <u>
            <span style="font-size:16.0pt;font-family:宋体;">冶金煤</span>
          </u>
        </b>
      </p>
      <p>
        <span style="font-family:Arial;">&nbsp;</span>
      </p>
      <p>
        <span style="font-size:12pt;font-family:Arial;">
          <span style="font-size:12px;">
            Silicon
            Coal/ PCI:
          </span>
          <br>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <table
        style="border-collapse:collapse;border:none;"
        border="1"
        cellpadding="0"
        cellspacing="0"
      >
        <tbody>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="175">
              <p>
                <span style="font-size:12px;font-family:'} ';">&nbsp;</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="180">
              <p>
                <span style="font-size:12px;font-family:'} ';">
                  TYPE
                  A (medium ash)
                </span>
                <span style="font-size:12px;font-family:宋体;">中灰份</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="156">
              <p>
                <span style="font-size:12px;font-family:'} ';">
                  TYPE
                  B (low ash)
                </span>
                <span style="font-size:12px;font-family:宋体;">低灰份</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="175">
              <p>
                <span style="font-size:12px;font-family:'} ';">Moisture</span>
                <span style="font-size:12px;font-family:宋体;">水分</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="180">
              <p>
                <span style="font-size:12px;font-family:'} ';">&nbsp;</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="156">
              <p>
                <span style="font-size:12px;font-family:'} ';">4.4%</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="175">
              <p>
                <span style="font-size:12px;font-family:'} ';">Ash</span>
                <span style="font-size:12px;font-family:宋体;">灰份</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="180">
              <p>
                <span style="font-size:12px;font-family:'} ';">
                  3%
                  max
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="156">
              <p>
                <span style="font-size:12px;font-family:'} ';">
                  1.5%
                  max
                </span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="175">
              <p>
                <span style="font-size:12px;font-family:'} ';">Ti02</span>
                <span style="font-size:12px;font-family:宋体;">钛</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="180">
              <p>
                <span style="font-size:12px;font-family:'} ';">
                  .25
                  max
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="156">
              <p>
                <span style="font-size:12px;font-family:'} ';">
                  .1
                  max
                </span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="175">
              <p>
                <span style="font-size:12px;font-family:'} ';">
                  Al2O3
                  (in coal)
                </span>
                <span style="font-size:12px;font-family:宋体;">铝</span>
                <span style="font-size:12px;font-family:'} ';">(</span>
                <span style="font-size:12px;font-family:宋体;">煤中含量</span>
                <span style="font-size:12px;font-family:'} ';">)</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="180">
              <p>
                <span style="font-size:12px;font-family:'} ';">
                  .6
                  max
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="156">
              <p>
                <span style="font-size:12px;font-family:'} ';">
                  .5
                  max
                </span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="175">
              <p>
                <span style="font-size:12px;font-family:'} ';">
                  DFC
                  (dry fixed carbon)
                </span>
                <span style="font-size:12px;font-family:宋体;">固定碳</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="180">
              <p>
                <span style="font-size:12px;font-family:'} ';">
                  54%
                  min
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="156">
              <p>
                <span style="font-size:12px;font-family:'} ';">57%</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="175">
              <p>
                <span style="font-size:12px;font-family:'} ';">Fe203</span>
                <span style="font-size:12px;font-family:宋体;">铁</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="180">
              <p>
                <span style="font-size:12px;font-family:'} ';">
                  .3
                  max
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="156">
              <p>
                <span style="font-size:12px;font-family:'} ';">
                  .27%
                  max
                </span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="175">
              <p>
                <span style="font-size:12px;font-family:'} ';">CaO</span>
                <span style="font-size:12px;font-family:宋体;">钙</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="180">
              <p>
                <span style="font-size:12px;font-family:'} ';">
                  .3
                  max
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="156">
              <p>
                <span style="font-size:12px;font-family:'} ';">
                  .3
                  max
                </span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="175">
              <p>
                <span style="font-size:12px;font-family:'} ';">
                  Dry
                  S
                </span>
                <span style="font-size:12px;font-family:宋体;">硫</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="180">
              <p>
                <span style="font-size:12px;font-family:'} ';">
                  1.2%
                  max
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="156">
              <p>
                <span style="font-size:12px;font-family:'} ';">1.03%</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="175">
              <p>
                <span style="font-size:12px;font-family:'} ';">Volatile</span>
                <span style="font-size:12px;font-family:宋体;">挥发份</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="180">
              <p>
                <span style="font-size:12px;font-family:'} ';">
                  43%
                  max
                </span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="156">
              <p>
                <span style="font-size:12px;font-family:'} ';">41.5</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="175">
              <p>
                <span style="font-size:12px;font-family:宋体;">粘结指数</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="180">
              <p>
                <span style="font-size:12px;font-family:'} ';">94</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="156">
              <p>
                <span style="font-size:12px;font-family:'} ';">97</span>
              </p>
            </td>
          </tr>
          <tr>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="175">
              <p>
                <span style="font-size:12px;font-family:宋体;">胶质层</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="180">
              <p>
                <span style="font-size:12px;font-family:'} ';">14.5</span>
              </p>
            </td>
            <td style="border:solid windowtext 1.0pt;" valign="top" width="156">
              <p>
                <span style="font-size:12px;font-family:'} ';">14</span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>

      <p></p>
      <p>
        <br>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        yjm: require("../../../assets/img/common/yjm.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/zh/product/yjm.vue